import { ActionsCell } from '../../../../../Component/Common/Components/DataTable/ActionsCell';
import { ActionsCellWithBadge } from '../../../../../Component/Common/Components/DataTable/ActionsCellWithBadge';
import { DefaultCell } from '../../../../../Component/Common/Components/DataTable/DefaultCell';
import { IRowAction } from '../../../../../Component/Common/Components/DataTable/RowAction';
import { DataTableHtmlFormatter } from '../../../../../Component/Model/helpers';
import { Deviations } from '../../../../../Component/Model/Dto/EmploymentEquity/Deviations';
import { TableColumn } from '../../../../../Component/Model/Table/Table';

interface DemographicJustificationsRow {
    id: number;
    demographicGroup: string;
    justifiableReason: string;
    comment: string;
    SupportingDocuments: IRowAction[];
    Actions: IRowAction[];
}

interface DemographicJustificationsTableData {
    columns: Array<TableColumn>;
    rows: Array<DemographicJustificationsRow>;
}

export function DemographicJustificationsTableMapper(
    dataObject: Deviations.SearchResultDto[],
    handleEdit: (id: number) => void,
    handleConfirmDelete: (id: number) => void,
    handleDocuments: (id: number) => void
): DemographicJustificationsTableData {
    const columns: TableColumn[] = [
        {
            Header: 'Demographic Group',
            accessor: 'demographicGroup',
            Cell: ({ value }: any) => <DefaultCell value={value} />,
            disableSortBy: true,
        },
        {
            Header: 'Justification Reason',
            accessor: 'justifiableReason',
            Cell: ({ value }: any) => <DefaultCell value={value} tooltip={true} maxWidth={'350px'} />,
            disableSortBy: true,
        },
        {
            Header: 'Commentary',
            accessor: 'comment',
            Cell: ({ value }: any) => <DefaultCell value={value} tooltip={true} maxWidth={'350px'} />,
            disableSortBy: true,
        },
        {
            Header: 'Documents',
            accessor: 'SupportingDocuments',
            Cell: ({ value }: any) => <ActionsCellWithBadge actions={value} />,
            disableSortBy: true,
        },
        {
            Header: 'Actions',
            accessor: 'Actions',
            Cell: ({ value }: any) => <ActionsCell actions={value} />,
            disableSortBy: true,
        },
    ];

    const rows = (dataObject ?? []).map((item: Deviations.SearchResultDto) => ({
        id: item.id,
        demographicGroup: [item.race, item.gender].filter(Boolean).join(' '),
        justifiableReason: item.justifiableReason ?? '',
        comment: DataTableHtmlFormatter(item.comment ?? '', ' '),
        SupportingDocuments: [
            {
                label: 'Supporting Documents',
                key: String(item.id),
                action: (id: string) => handleDocuments(Number(id)),
                badgeCount: item.documentCount,
                showBadge: true,
                icon: { color: 'info' as const, name: 'attach_file' },
            },
        ],
        Actions: [
            {
                label: 'Edit',
                key: String(item.id),
                action: (id: string) => handleEdit(Number(id)),
                icon: { color: 'info' as const, name: 'edit' },
            },
            {
                label: 'Delete',
                key: String(item.id),
                action: (id: string) => handleConfirmDelete(Number(id)),
                icon: { color: 'error' as const, name: 'delete' },
            },
        ],
    }));

    return { columns, rows };
}
